import { z } from "zod";

export const getCartFormSchema = (
  totalPrice: number,
  hasSubscription: boolean,
  isOrderFromBackend: boolean = false
) =>
  z
    .object({
      // رقم الجوال مطلوب إذا كان هناك اشتراك أو إذا كان الخصم 100% (فاتورة هدية)
      // ولكن ليس للطلبات القادمة من الباك اند
      phone:
        !isOrderFromBackend && (hasSubscription || totalPrice === 0)
          ? z
              .string({ required_error: "رقم الجوال مطلوب" })
              .min(1, "رقم الجوال مطلوب")
              .regex(
                /^\d{9,10}$/,
                "يرجى إدخال رقم جوال صحيح مكوّن من 9 إلى 10 أرقام"
              )
          : z
              .string()
              .optional()
              .refine((v) => !v || v.trim() === "" || /^\d{9,10}$/.test(v), {
                message: "يرجى إدخال رقم جوال صحيح مكوّن من 9 إلى 10 أرقام",
              }),
      discountCode: z.string().optional(),
      cashAmount: z.coerce
        .number()
        .min(0, "مبلغ نقدي غير صالح")
        .max(totalPrice, "المبلغ النقدي لا يمكن أن يتجاوز السعر الكلي"),
      cardAmount: z.coerce.number().min(0, "مبلغ شبكة غير صالح"),
    })
    .superRefine((data, ctx) => {
      const totalPaid = data.cashAmount + data.cardAmount;
      // السماح بقيمة 0 عند كون المبلغ المطلوب 0 (خصم 100%)
      if (totalPrice > 0) {
        const roundedPaid = Number(totalPaid.toFixed(2));
        const roundedPrice = Number(totalPrice.toFixed(2));
        if (roundedPaid === 0 || roundedPaid < roundedPrice) {
          const message =
            roundedPaid === 0
              ? "يجب دفع جزء من المبلغ نقدًا أو شبكة"
              : `المبلغ الإجمالي المدفوع (${roundedPaid}) أقل من السعر المطلوب (${roundedPrice})`;
          ctx.addIssue({ path: ["cashAmount"], message, code: "custom" });
          ctx.addIssue({ path: ["cardAmount"], message, code: "custom" });
        }
      }
    });
